module.exports = __webpack_public_path__ + "img/monitors.dd507b45.svg";